import React, { ReactElement } from 'react';

interface OLIProps {
  label: string,
  data: string | null | undefined,
  className?: string,
}

/**
 * Displays the <li> tag if and only if the data
 * param is not falsy ("", null, etc)
 *
 * @param label string
 * @param data string
 * @returns ReactElement
 */
const OptionalListItem: React.FC<OLIProps> = ({
  label,
  data,
  className,
}): ReactElement => {
  if (!data) {
    return (<></>);
  }

  return (
    <li className={className || ''}>
      <strong>
        {`${label}: `}
      </strong>
      <span>{data}</span>
    </li>
  );
};

export default OptionalListItem;
